import { CanActivate, Router, UrlTree } from '@angular/router';
import { Injectable, inject } from '@angular/core';

import { AuthService } from '../../auth/services/auth.service';
import { HOME_ROUTE } from '../constant/route.constant';
import { TokenStoreService } from '../services/token-store.service';

// A saved token goes to Home only if the API takes it. While the API is down the sign-in page
// shows, so this guard and SignedInGuard do not send the person back and forth.
@Injectable({ providedIn: 'root' })
export class SignedOutGuard implements CanActivate {
    private readonly authService = inject(AuthService);
    private readonly router = inject(Router);
    private readonly tokenStore = inject(TokenStoreService);

    async canActivate(): Promise<boolean | UrlTree> {
        if (!this.tokenStore.read()) return true;

        return this.authService
            .fetchLoggedInUser(true)
            .then(() => this.router.parseUrl(HOME_ROUTE))
            .catch(() => true);
    }
}
